// The API now always includes the demo company (id 1, is_demo: true) in every
// user's company list. These helpers keep "which company is selected" and
// "does this user have any real company" logic in one place, pure and testable.

// Choose the company to select on load/refresh.
// Priority (same order for admins and non-admins): (a) the saved companyId,
// if it points at a real (!is_demo) company in the list; (b) the first real
// company; (c) the saved companyId, if it points at a demo company; (d) the
// first demo company. A real company always wins over a saved *demo* id, so
// a user who browsed the demo and was later added to a real company lands on
// the real one instead of staying stuck on the demo.
export function chooseInitialCompany(companies, savedId, isAdmin) {
  if (!companies || companies.length === 0) {
    return undefined;
  }

  let saved;
  if (savedId !== undefined && savedId !== null && savedId !== '') {
    saved = companies.find((c) => c.id === +savedId);
  }

  if (saved && !saved.is_demo) {
    return saved;
  }

  const realCompany = companies.find((c) => !c.is_demo);
  if (realCompany) {
    return realCompany;
  }

  if (saved) {
    return saved;
  }

  return companies.find((c) => c.is_demo) || companies[0];
}

// A non-admin user with no real company (every company in their list is the
// demo) still needs the onboarding flow. Global admins never get it.
export function computeNoCompanies(companyList, isAdmin) {
  if (isAdmin) {
    return false;
  }

  if (!companyList || companyList.length === 0) {
    return true;
  }

  return companyList.every((c) => c.is_demo);
}
